import { TBaseEvent, TError, TEvent, TSelectContent } from 'types'

import { interWbSession } from '@interco/inter-webview-bridge'

export const appVersionLowerThanCurrent = (appInfo: unknown, targetVersion: string): boolean => {
  const currentVersion = (appInfo as { appVersion?: string })?.appVersion
  if (!currentVersion) return false

  const current = currentVersion.split('.').map(Number)
  const target = targetVersion.split('.').map(Number)

  for (let i = 0; i < Math.max(current.length, target.length); i++) {
    const currentPart = current[i] || 0
    const targetPart = target[i] || 0

    if (currentPart > targetPart) return true
    if (currentPart < targetPart) return false
  }

  return false
}

export const validateIsKidsAccount = (birthData: number | undefined) => {
  if (birthData) {
    const birthDate = new Date(birthData)
    const birthDay = birthDate.getDate()
    const birthMonth = birthDate.getMonth()

    const now = new Date()
    const actualDay = now.getDate()
    const actualMonth = now.getMonth()

    const yearDiff = now.getFullYear() - birthDate.getFullYear()

    return yearDiff < 18 || (yearDiff === 18 && actualMonth <= birthMonth && actualDay < birthDay)
  }

  return false
}

export function makeScreenName({ product_name, flow, step }: TBaseEvent) {
  return `${product_name}/${flow}/${step}`
}

export async function sendScreenView({
  product_name = 'inter_id',
  product = 'inter_id',
  flow = 'login_with_inter',
  step,
  scenario,
  event_name = 'screen_view',
}: TEvent) {
  const screen_name = makeScreenName({ product_name, flow, step })

  return interWbSession.requestAnalytics(event_name, {
    product_name,
    product,
    flow,
    step,
    screen_name,
    scenario,
    event_name,
  })
}

export async function sendError({
  product_name = 'inter_id',
  product = 'inter_id',
  flow = 'login_with_inter',
  step,
  scenario,
  error_description,
  error_message,
  event_name = 'error',
}: TError) {
  const screen_name = makeScreenName({ product_name, flow, step })

  return interWbSession.requestAnalytics(event_name, {
    product_name,
    product,
    flow,
    step,
    screen_name,
    scenario,
    error_description,
    error_message,
    event_name,
  })
}

export async function sendSelectContent({
  product_name = 'inter_id',
  product = 'inter_id',
  flow = 'login_with_inter',
  step,
  scenario,
  element_name,
  element_type,
  parent_name,
  event_name = 'select_content',
}: TSelectContent) {
  const screen_name = makeScreenName({ product_name, flow, step })

  return interWbSession.requestAnalytics(event_name, {
    product_name,
    product,
    flow,
    step,
    screen_name,
    scenario,
    element_name: element_name.replaceAll(' ', '_').toLocaleLowerCase(),
    element_type,
    parent_name,
    event_name,
  })
}
